import { API, graphqlOperation } from 'aws-amplify';
import { GraphQLResult } from '@aws-amplify/api-graphql';
import { createAITraining } from '../../../../graphql/mutations';

interface CreateAITrainingInput {
  orgID: string;
  service: string;
  name: string;
  description?: string;
  prompt: string;
  revision: number;
  status?: string;
  users?: string[];
  public?: boolean;
  createdBy?: string;
  lastUpdatedBy?: string;
  isDeleted?: boolean;
}

interface CreateAITrainingResponse {
  createAITraining: {
    id: string;
    orgID: string;
    service: string;
    name: string;
    description?: string;
    prompt: string;
    revision: number;
    status?: string;
    users?: string[];
    public?: boolean;
    createdBy?: string;
    lastUpdatedBy?: string;
    createdAt: string;
    updatedAt: string;
  };
}

export async function createAITrainingEntry(
  input: CreateAITrainingInput
): Promise<CreateAITrainingResponse['createAITraining'] | null> {
  try {
    // @ts-ignore
    const { me } = global;

    const trainingInput = {
      public: false,
      createdBy: me.id,
      lastUpdatedBy: me.id,
      isDeleted: false,
      ...input, // Spread input last so revision and other values are not overridden
    };

    const result = (await API.graphql(
      graphqlOperation(createAITraining, {
        input: trainingInput,
      })
    )) as GraphQLResult<CreateAITrainingResponse>;

    const createdTraining = result.data?.createAITraining;
    if (createdTraining) {
      console.log(`AI Training ${createdTraining.name} created successfully.`);
      return createdTraining;
    } else {
      console.error(
        `Failed to create AI training for service: ${input.service}`
      );
      return null;
    }
  } catch (error) {
    console.error('Error creating AI training:', error);
    throw error;
  }
}
